import { AfterContentInit, Component, OnDestroy, OnInit } from "@angular/core";
import {
  NbMediaBreakpointsService,
  NbMenuItem,
  NbSidebarService,
  NbThemeService,
  NbMenuService,
  NbMenuBag,
} from "@nebular/theme";

import { NavigationExtras, Router } from "@angular/router";
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";

import { Home } from "../../../@core/models/home";
import { AppUser } from "../../../@core/models/app.user";
import { AppUserMenu } from "../../../@core/models/app.user.menu";

import { LoginService } from "../../../@core/data/login.service";
import { GeneralService } from "../../../@core/data/general.service";
import { LayoutService } from "../../../@core/utils";
import { StorageService } from "../../../@core/data/storage.service";

import { HeaderFormComponent } from "./form.header.component";
import { ModalMenuComponent } from "../../../timeline/modal-menu/modal-menu.component";
import { HeaderDialogContactComponent } from "./dialog-contact.component";

import { map, takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";

import { generalSettings } from "../../../../main/settings";

import { environment } from "../../../../environments/environment";

declare var cast: any;

@Component({
  selector: "edm-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
  standalone: false,
})
export class HeaderComponent implements OnInit, AfterContentInit, OnDestroy {

  pathBaseTranslate: string = "theme.components.header.";

  nbMenuBag: Subscription;

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;

  user: AppUser = null;
  home: Home = null;

  headerMenu: boolean;
  headerMenuItems: number;
  enableTimeline: boolean;
  enableSocialMedia: boolean;
  enableExplore: boolean;
  enableSearchButton: boolean;
  enableMenuLink: boolean;

  generalSettings: any;

  userMenu: NbMenuItem[] = [];
  extrasMenuItems: boolean = false;

  openingPopUp: boolean = false;

  inAppRegistration: boolean = false;
  myList: boolean = false;
  myCertificates: boolean = false;

  activeMenu!: boolean;

  ngbModalOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size: "lg",
    container: "nb-layout",
  };

  userMenu$ = new Subscription();

  menu: AppUserMenu;

  constructor(
    private modal: NgbModal,
    private menuService: NbMenuService,
    private sidebarService: NbSidebarService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private loginService: LoginService,
    private generalService: GeneralService,
    private storageService: StorageService,
    public router: Router
  ) {
    const gs: any = generalSettings;
    this.enableTimeline = gs.enableTimeline;
    this.enableSocialMedia = gs.enableSociaMedia;
    this.enableExplore = false;
    this.enableSearchButton = gs.enableSearch;
    this.headerMenu =
      this.enableTimeline || this.enableSocialMedia || this.enableExplore;
    this.inAppRegistration = generalSettings.inAppRegistration;
    this.myList = generalSettings.myList;
    this.myCertificates = generalSettings.certificates;
    this.headerMenuItems =
      this.booleanToNumber(this.enableTimeline) +
      this.booleanToNumber(this.enableSocialMedia) +
      this.booleanToNumber(this.enableExplore);
    this.generalSettings = generalSettings;
    this.nbMenuBag = this.menuService
    .onItemClick()
    .subscribe((menu: NbMenuBag): void => {
      if (
        menu.item.data !== undefined &&
        menu.item.data.id !== undefined &&
        menu.item.data.id == "password"
      ) {
        this.openPassword();
      }
      if (
        menu.item.data !== undefined &&
        menu.item.data.id !== undefined &&
        menu.item.data.id == "contact"
      ) {
        this.openContact();
      }
    });
  }

  ngOnInit(): void {
    if (this.loginService.isAuthenticated()) {
      this.getLoggedUser();
    } else {
      this.enableMenuLink = false;
      this.generalService.home().then((home: Home): void => {
        this.home = home;
        this.syncExploreFeature();
      });
    }
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
    .onMediaQueryChange()
    .pipe(
      map(([, currentBreakpoint]): boolean => currentBreakpoint.width < xl),
      takeUntil(this.destroy$)
    )
    .subscribe(
      (isLessThanXl: boolean): boolean =>
        (this.userPictureOnly = isLessThanXl)
    );
    this.loginService.user$.subscribe((item) => {
      if (item) {
        this.userMenu = [];
        this.loginService.storedLoggedUser = null;
        if (this.loginService.isAuthenticated()) {
          this.getLoggedUser();
        }
      }
    });
    if (environment.appname == "Time Verde") this.initializeGoogleCast();
  }

  ngAfterContentInit(): void {
    if (this.loginService.isAuthenticated()) {
      if (!this.exists(this.menu)) {
        //const storedMenu: AppUserMenu = this.storageService.restoreObject('app_logged_user_menu');
        //console.log(storedMenu);

        if(!this.generalService.menu){
          this.generalService.userMenu().then(
            (done: any): void => {
              this.menu = done;
            },
            (error: HttpErrorResponse | any): void => {
              if (error.status == 401) this.router.navigate(["logout"]);
              const erro = error;
              error.errors = true;

            }
          );
          return
        }

        this.menu = this.generalService.menu;

        }
    }
  }

  getLoggedUser(): void {
    if (this.storageService.restoreObject('app_logged_user')) {
      const user: AppUser = this.storageService.restoreObject('app_logged_user')
      this.user = user;
      this.enableMenuLink = true;
      this.getHome();
    } else {
      this.loginService.loggedUser$.subscribe((loggedUser: AppUser): void => {
        if (this.exists(loggedUser)) {
          this.user = loggedUser;
          this.enableMenuLink = true;
          this.getHome();
        } else this.getHome();
      });
    }
  }

  getHome(): void {
    if (this.storageService.restoreObject('home_config')) {
      const home: Home = this.storageService.restoreObject('home_config');
      this.home = home;
      this.syncExploreFeature();
      this.generalService.store(this.home, "home", true);
      this.loadExtraMenuItems();
    } else {
      this.generalService.home().then((home: Home): void => {
        this.home = home;
        this.syncExploreFeature();
        this.generalService.store(this.home, "home", true);
        this.loadExtraMenuItems();
      });
    }
  }

  ngOnDestroy(): void {
    this.nbMenuBag.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
    this.userMenu$?.unsubscribe();
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "menu-sidebar");
    this.layoutService.changeLayoutSize();
    return false;
  }

  navigateHome(): boolean {
    this.router.navigate(["/"]);
    return false;
  }

  navigateLogin(): boolean {
    const extras: NavigationExtras = {
      queryParams: { redirect: encodeURIComponent(this.router.url) },
    };
    this.router.navigate(["login"], extras);
    return false;
  }

  navigateNotifications(): boolean {
    this.router.navigate(["/sdui"], {
      queryParams: { path: "user/notifications" },
    });
    return false;
  }

  isAuthenticated(): boolean {
    return this.loginService.isAuthenticated();
  }

  hasNotifications(): boolean {
    return Number(this.user?.notifications_count || 0) > 0;
  }

  isNotificationsRoute(): boolean {
    const urlTree = this.router.parseUrl(this.router.url || "");
    const primaryPath: string = "/" + (urlTree.root.children["primary"]?.segments || [])
      .map((segment) => segment.path)
      .join("/");
    const pathQuery: string = urlTree.queryParams["path"] || urlTree.queryParams["sduiUrl"] || "";

    return primaryPath.includes("/notifications") || pathQuery === "user/notifications";
  }

  headerMenuItemClass(route: string): string {
    const path = this.router.url.split('?')[0];
    const routerPaths: string[] = path.split("/");
    const active: boolean =
      routerPaths.length > 0 &&
      routerPaths.findIndex((x: string): boolean => x == route) > -1;
    return active ? "active" : "";
  }

  isRouteActive(route: string): boolean {
    const path = this.router.url.split('?')[0];
    const routerPaths: string[] = path.split("/");
    return (
      routerPaths.length > 0 &&
      routerPaths.findIndex((x: string): boolean => x == route) > -1
    );
  }

  private loadExtraMenuItems(): void {
    if (this.home !== null && this.home !== undefined) {
      this.assemblyMenu(this.home);
    }
  }

  private assemblyMenu(model: Home): void {
    this.extrasMenuItems = true;
    this.userMenu = [];
    this.userMenu.push({
      title: this.getTranslate("profileLabel"),
      link: "perfil",
      queryParams: { from: encodeURIComponent(this.router.url) },
    });
    this.userMenu.push({
      title: this.getTranslate("changePasswordLabel"),
      data: { id: "password" },
    });
    this.userMenu.push({
      title: this.getTranslate("supportLabel"),
      link: "perfil/suporte",
      queryParams: { from: encodeURIComponent(this.router.url) },
    });
    this.userMenu.push({
      title: this.getTranslate("logout"),
      link: "logout",
    });
  }

  getTranslate(key: string): string {
    return this.generalService.getTranslate(`${this.pathBaseTranslate}${key}`);
  }

  getTimelineLabel(): string {
    return this.generalService.getTimelineLabel();
  }

  getSocialMediaLabel(): string {
    return this.generalService.getSocialMediaLabel();
  }

  getExploreLabel(): string {
    return this.generalService.getExploreLabel();
  }

  exists(object: Object): boolean {
    return object !== null && object !== undefined && object != "";
  }

  firstName(name: string): string {
    if (!name) return "";
    return name.trim().split(" ")[0];
  }

  private booleanToNumber(value: boolean): number {
    return value ? 1 : 0;
  }

  private syncExploreFeature(): void {
    this.enableExplore = this.generalService.isExploreEnabled(this.home);
    this.headerMenu =
      this.enableTimeline || this.enableSocialMedia || this.enableExplore;
    this.headerMenuItems =
      this.booleanToNumber(this.enableTimeline) +
      this.booleanToNumber(this.enableSocialMedia) +
      this.booleanToNumber(this.enableExplore);
  }

  private openPassword(): void {
    if (!this.openingPopUp) {
      this.openingPopUp = true;
      const activeModal: NgbModalRef = this.modal.open(
        HeaderFormComponent,
        this.ngbModalOptions
      );
      activeModal.result.then(
        (done: AppUser | string): void => {
          if (done && done !== null) {
            if (done == "error") {
              this.openingPopUp = false;
            } else {
              this.showToastService(
                "success",
                this.getTranslate("successAlert"),
                this.getTranslate("successMessage")
              );
              this.loginService.storeToken((done as AppUser).api_token);
              this.openingPopUp = false;
            }
          }
        },
        (): void => {
          this.openingPopUp = false;
        }
      );
    }
  }

  private openContact(): void {
    if (!this.openingPopUp) {
      this.openingPopUp = true;
      const activeModal: NgbModalRef = this.modal.open(
        HeaderDialogContactComponent,
        this.ngbModalOptions
      );
      activeModal.componentInstance.contact = this.home.contact;
      activeModal.result.then(
        (): void => {
          this.openingPopUp = false;
        },
        (): void => {
          this.openingPopUp = false;
        }
      );
    }
  }

  /*
  ---------- C A S T   F U N C T I O N S ----------
  */

  private initializeGoogleCast(): void {
    const castX = window as any;
    if(castX.cast){
      let context: any = cast?.framework.CastContext.getInstance();
      let castSession: any = context?.getCurrentSession();
      if (this.exists(castSession)) {
        castSession.sendMessage("urn:x-cast:br.com.edm.cast.clientname", "verde");
        castSession.sendMessage(
          "urn:x-cast:br.com.edm.cast.readytocast",
          "Cast into the future"
        );
      }
      context?.addEventListener(
        cast.framework.CastContextEventType.SESSION_STATE_CHANGED,
        (status: { sessionState: string }): void => {
          if (
            status.sessionState == cast.framework.SessionState.SESSION_STARTED ||
            status.sessionState == cast.framework.SessionState.SESSION_RESUMED
          ) {
            var castSession = context.getCurrentSession();
            if (this.exists(castSession)) {
              castSession.sendMessage(
                "urn:x-cast:br.com.edm.cast.clientname",
                "verde"
              );
              castSession.sendMessage(
                "urn:x-cast:br.com.edm.cast.readytocast",
                "Cast into the future"
              );
            }
          }
        }
      );
    }

  }

  /*
  ---------- G E N E R A L   F U N C T I O N S ----------
  */

  iconTypeLayoutClass(): string {
    return generalSettings.iconsType + "-icons-type";
  }

  private showToastService(type: "success" | "warning" | "error", title?: string, message?: string): void {
    this.generalService.showToastService(type, message, title);
  }

  public openModalMenu(): void {
    this.activeMenu = true;
    const activeModal: NgbModalRef = this.modal.open(
      ModalMenuComponent,
      this.ngbModalOptions
    );
    activeModal.componentInstance.menu = this.menu;
    activeModal.result.then(
      () => {},
      () => {
        this.activeMenu = false;
      }
    );
  }
}
